import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
//shared libs

//services
import { TranslateService } from '@ngx-translate/core';
import { SecLogins, UsersGroupService } from '../usersGroup.service';
import { UserSessionService } from '../../../shared/shared';

@Component({
    selector: 'AddUserGroupPopup',
    templateUrl: './add-user-group-popup.component.html'
})


export class AddUserGroupPopupComponent implements OnInit, OnDestroy {
    master: any = <any>{};
    editSecLogins: SecLogins = <SecLogins>{};
    SecLoginsForm: UntypedFormGroup;
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private _usersGroupService: UsersGroupService,
        private _userSessionService: UserSessionService,
        public translate: TranslateService) {
    }

    ngOnInit() {
        this.SecLoginsInit();
        // for first time get model key by this way and get seclogins after it
        this.master = this._userSessionService.getModalKey('AddUserGroupPopupComponent')['inputs'];
        this.getSecLogins();
        // second subscribe to model key to get data continiously
        this._userSessionService.getModalKey$()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                this.master = <any>{};
                if (keys.name == 'AddUserGroupPopupComponent' && keys.inputs) {
                    this.master = keys.inputs;
                    this.getSecLogins();
                }
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.resetForm();
    }

    // initialize SecLogins form
    SecLoginsInit() {
        this.SecLoginsForm = new UntypedFormGroup({
            id: new UntypedFormControl(),
            groupId: new UntypedFormControl(),
            userId: new UntypedFormControl('', Validators.required),
            branchId: new UntypedFormControl('', Validators.required),
        })
    }
    resetForm() {
        this.SecLoginsForm.reset();
    }

    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
        }
    }

    //#region Crud operations

    getSecLogins() {
        if (this.SecLoginsForm) {
            this.SecLoginsForm.reset();
            this.SecLoginsForm.patchValue(this.master);
        }
    }

    save() {
        this.editSecLogins = this.SecLoginsForm.value;
        this.editSecLogins.groupId = this.master.groupId;
        if (this.editSecLogins.id == null) {
            this.editSecLogins.id = 0;
            this._usersGroupService.addSecLogins(this.editSecLogins)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (c && c.returnFlag == true) {
                    }
                });
        }
        else {
            this._usersGroupService.updateSecLogins(this.editSecLogins)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (c && c.returnFlag == true) { }
                });
        }
    }
}